import React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { IAppState } from '../store/state.interface.web'
import { useSelector } from 'react-redux'
import { getIsSuperUser, getIsAdmin } from './Login/login.selector'
import { IUser } from '../users/index.interface';

interface IProps extends RouteProps {
  token: string,
  CustomComp: any,
  permissions: IPermissionsInterface

}
interface IPermissionsInterface {
  suAccess: boolean
  adminAccess: boolean
  userAccess: boolean
}
const PrivateRoute: React.SFC<IProps> = ({
  token,
  CustomComp,
  permissions,
  ...rest
}) => {
  const isSuperUser = useSelector<IAppState, boolean>(state =>
    getIsSuperUser(state)!
  )
  const isAdmin = useSelector<IAppState, boolean>(state =>
    getIsAdmin(state)!
  )
  const loggedInUser = useSelector<IAppState, Partial<IUser>>(
    (state: IAppState) => state.login.user
  )
  const loadingUser = useSelector<IAppState, boolean>(
    (state: IAppState) => state.login.loading
  )

  const hasAccess = (): boolean => {
    if (permissions.suAccess && isSuperUser) {
      return true
    } else if (permissions.adminAccess && isAdmin) {
      return true
    } else if (permissions.userAccess && !isAdmin) {
      return true
    } else {
      return (false)
    }
  }
  return (
    <Route
      {...rest}
      render={props => {
        const redirectionRoute = {
          pathname: '/login',
          state: { from: props.location }
        }
        const noAccessRoute = {
          pathname: '/',
          state: { from: props.location }
        }
        if (token) {
          const lazyLoader = <div className="lazy-loader"><em className="fas fa-circle-notch fa-spin fa-2x text-muted" /></div>
          if (loadingUser || !loggedInUser.id) {
            return lazyLoader
          }
          if (hasAccess()) {
            return <CustomComp {...props} />
          } else {
            return <Redirect to={noAccessRoute} />
          }
        } else {
          return <Redirect to={redirectionRoute} />
        }
      }}
    />
  )
}

export default PrivateRoute
